// ** React Imports
import { forwardRef, memo, useContext, useMemo } from 'react'

// ** MUI Imports
import MuiAvatar from '@mui/material/Avatar'
import { lighten, useTheme } from '@mui/material/styles'

// ** Hooks Imports
import UseBgColor from '../../hooks/useBgColor'
import { SettingsContext } from '../../context/setting'

const Avatar = forwardRef((props, ref) => {
  // Context
  const {
    settings: { mode }
  } = useContext(SettingsContext)

  // ** Props
  const { sx, src, color } = props

  // ** Hook
  const theme = useTheme()
  const bgColors = UseBgColor()

  // variables
  const skin = useMemo(() => mode, [mode])

  const getAvatarStyles = (skin, skinColor) => {
    let avatarStyles
    if (skin === 'light') {
      avatarStyles = { ...bgColors[`${skinColor}Light`] }
    } else if (skin === 'light-static') {
      avatarStyles = {
        color: bgColors[`${skinColor}Light`].color,
        backgroundColor: lighten(theme.palette[skinColor].main, 0.88)
      }
    } else {
      avatarStyles = { ...bgColors[`${skinColor}Filled`] }
    }

    return avatarStyles
  }

  const colors = {
    primary: getAvatarStyles(skin, 'primary'),
    secondary: getAvatarStyles(skin, 'secondary'),
    success: getAvatarStyles(skin, 'success'),
    error: getAvatarStyles(skin, 'error'),
    warning: getAvatarStyles(skin, 'warning'),
    info: getAvatarStyles(skin, 'info')
  }

  return (
    <MuiAvatar
      ref={ref}
      {...props}
      sx={!src && skin && color ? Object.assign(colors[color], sx) : sx}
    />
  )
})
Avatar.defaultProps = {
  skin: 'filled',
  color: 'primary'
}

export default memo(Avatar)
